import api from "./httpClient";

const API_URL = "/NewScope";

export const getAllScopes = async (
  pageNumber = 1,
  pageSize = 20,
  sortBy = "PlannedDate",
  sortDirection = "desc",
  signal,
) => {
  const res = await api.post(
    `${API_URL}/List`,
    {
      offset: (pageNumber - 1) * pageSize,
      limit: pageSize,
      sort: sortBy,
      order: sortDirection,
      search: {},
    },
    { signal },
  );

  return res.data;
};

export const createScope = async (scope) => {
  return api.post(API_URL, {
    data: scope,
  });
};

export default {
  getAllScopes,
  createScope,
};
